export * from './AgeGenderNet';
export * from './types';
//# sourceMappingURL=index.js.map